var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('div',{staticClass:"s-card-box-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"s-card-box-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }